<!-- Overlay to block interactions when needed -->
<div *ngIf="isVisible" class="overlay-blocker">
    <button mat-raised-button [color]="buttonColor" class="overlay-toggle-btn" (click)="onButtonClick()">
        {{ buttonText }}
    </button>
</div>